import { render } from "./elem-input.vue?vue&type=template&id=c05b906c&ts=true"
import script from "./elem-input.vue?vue&type=script&lang=ts"
export * from "./elem-input.vue?vue&type=script&lang=ts"

import "./elem-input.vue?vue&type=style&index=0&id=c05b906c&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__